// ---------------------------------------------------------------------------
// cartStorage.js — persist cart lines in localStorage, keyed by tenantId
// ---------------------------------------------------------------------------

const CART_KEY_PREFIX = "pingup_cart_v1";

function storageKey(tenantId) {
  return `${CART_KEY_PREFIX}_${String(tenantId || "default")}`;
}

/**
 * Save cart lines array to localStorage.
 * Silent-fails if localStorage is unavailable (private mode, quota exceeded).
 */
export function saveCart(tenantId, cartLines) {
  try {
    localStorage.setItem(storageKey(tenantId), JSON.stringify(Array.isArray(cartLines) ? cartLines : []));
  } catch {
    // ignore
  }
}

/**
 * Load cart lines from localStorage.
 * Returns an empty array on any error.
 */
export function loadCart(tenantId) {
  try {
    const raw = localStorage.getItem(storageKey(tenantId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Remove the cart for a specific tenant from localStorage.
 * Call this after a successful order submission.
 */
export function clearCart(tenantId) {
  try {
    localStorage.removeItem(storageKey(tenantId));
  } catch {
    // ignore
  }
}
